import { login, smsLogin } from '@/api/user'
import { getMyMembershipStatus } from '@/api/info'
import { getToken, setToken, removeToken, setUserInfo, removeUserInfo,
  removeRegisterInfo, setMembership } from '@/libs/cookie-storage'

const user = {
  state: {
    token: getToken(),
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo.tel, userInfo.password).then(response => {
          const data = response.data
          if (data.session && data.session.id) {
            setToken(data.session.id)
            setUserInfo(data.user)
            removeRegisterInfo()
            commit('SET_TOKEN', data.session.id)
            commit('SET_INFO', data.user)
            getMyMembershipStatus().then(response => {
              setMembership(response.data)
              resolve(true)
            })
          } else {
            resolve(false)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    SmsLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        smsLogin(userInfo).then(response => {
          const data = response.data
          if (data.session && data.session.id) {
            setToken(data.session.id)
            setUserInfo(data.user)
            removeRegisterInfo()
            commit('SET_TOKEN', data.session.id)
            commit('SET_INFO', data.user)
            getMyMembershipStatus().then(response => {
              setMembership(response.data)
              resolve(true)
            })
          } else {
            resolve(false)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const user = response.data.users
          resolve(user)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        removeUserInfo()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js